import React from "react";
import { Box, Typography, Link, Stack, IconButton, Divider } from "@mui/material";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import TwitterIcon  from "@mui/icons-material/Twitter";
import { useTranslation } from "react-i18next";
import glyphImg from "../../../../design-system/assets/brand/glyph.png";
import { privacyHref } from "../../../legal/privacyHref";

const COLS = [
  {
    title: "Product",
    links: ["Cloud PBX", "Call Flow Builder", "AI Insights", "Analytics", "Pricing"],
  },
  {
    title: "Solutions",
    links: ["Call Centers", "Sales Teams", "Support Teams", "Enterprise"],
  },
  {
    title: "Company",
    links: ["About", "Security", "Contact", "Privacy · Terms"],
  },
];

export default function Footer() {
  const { t, i18n } = useTranslation("home");
  const COL_TITLE_KEYS = ["footerColProduct", "footerColSolutions", "footerColCompany"];
  const COL_LINK_KEYS = [
    ["footerLinkCloudPBX", "footerLinkCallFlow", "footerLinkAIInsights", "footerLinkAnalytics", "footerLinkPricing"],
    ["footerLinkCallCenters", "footerLinkSalesTeams", "footerLinkSupportTeams", "footerLinkEnterprise"],
    ["footerLinkAbout", "footerLinkSecurity", "footerLinkContact", "footerLinkPrivacyTerms"],
  ];
  return (
    <Box
      component="footer"
      sx={{
        background: "#12142E",
        color: "#A9AEC9",
        pt: { xs: "44px", md: "52px" },
        pb: { xs: "24px", md: "30px" },
        px: { xs: 3, md: "56px" },
      }}
    >
      <Box sx={{
        maxWidth: 1320, mx: "auto",
        display: "grid",
        gridTemplateColumns: { xs: "1fr", sm: "1.6fr 1fr 1fr 1fr" },
        gap: { xs: "36px", md: "32px" },
        mb: { xs: "36px", md: "26px" },
      }}>
        {/* Brand column */}
        <Box>
          <Box
            component="img"
            src={glyphImg}
            alt="Teleredo"
            sx={{ height: 34, width: "auto", mb: "14px" }}
          />
          <Typography sx={{
            fontSize: "13px", lineHeight: 1.6, color: "#8A90B5",
            maxWidth: "34ch", fontFamily: "var(--font-ui)",
          }}>
            {t("footerBrandDesc")}
          </Typography>
          <Stack direction="row" gap={1} sx={{ mt: 2.5 }}>
            {[LinkedInIcon, TwitterIcon].map((Icon, i) => (
              <IconButton key={i} size="small" href="#" sx={{
                color: "rgba(255,255,255,.4)",
                border: "1px solid rgba(255,255,255,.1)", borderRadius: "8px",
                "&:hover": {
                  color: "#fff",
                  borderColor: "rgba(255,255,255,.25)",
                  background: "rgba(255,255,255,.06)",
                },
              }}>
                <Icon fontSize="small" />
              </IconButton>
            ))}
          </Stack>
        </Box>

        {/* Link columns */}
        {COLS.map(({ title, links }, ci) => (
          <Box key={title}>
            <Typography sx={{
              fontSize: "12px", fontWeight: 700, letterSpacing: ".06em",
              textTransform: "uppercase", color: "#6B7099",
              mb: "12px", fontFamily: "var(--font-ui)",
            }}>
              {t(COL_TITLE_KEYS[ci])}
            </Typography>
            <Stack gap="9px">
              {links.map((l, li) => (
                <Link key={l} href={COL_LINK_KEYS[ci][li] === "footerLinkPrivacyTerms" ? privacyHref(i18n.language) : "#"} underline="none" sx={{
                  fontSize: "13.5px", color: "#A9AEC9",
                  fontFamily: "var(--font-ui)",
                  transition: "color 0.15s",
                  "&:hover": { color: "#fff" },
                }}>
                  {t(COL_LINK_KEYS[ci][li], { defaultValue: l })}
                </Link>
              ))}
            </Stack>
          </Box>
        ))}
      </Box>

      <Divider sx={{ borderColor: "rgba(255,255,255,.08)", maxWidth: 1320, mx: "auto" }} />

      <Box sx={{
        maxWidth: 1320, mx: "auto",
        mt: "20px",
        display: "flex",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: "10px",
        fontSize: "12.5px",
        color: "#6B7099",
        fontFamily: "var(--font-ui)",
      }}>
        <span>{t("footerCopyright", { year: new Date().getFullYear() })}</span>
        <span>{t("footerPrivacyBar")}</span>
      </Box>
    </Box>
  );
}
